import { client } from '@canvas/rovo-content-bridge-api';

/**
 * The main static ID for the databases bridge client.
 */
export const CONFLUENCE_DATABASE_CLIENT_ID = client('confluence-database');

/**
 * The list of features supported by native embed.
 * Both clients must specify which features they currently support.
 *
 * These features align with the milestone-based rollout plan for native database embeds.
 * @see https://hello.atlassian.net/wiki/spaces/CD2/pages/4737992889/Feature+New+native+embed+whiteboards+pages
 */
export type NativeEmbedFeatureList = {
  /**
   * M1b Hello release: Toolbar/Action Bar
   * - Embed settings panel
   * - Sort panel
   * - Filter panel
   * - Hide fields panel
   * - Database templates & import configuration
   * - WBs Element Toolbar → DBs Action Bar: Cell Interactions
   * - View/Change views from element toolbar
   * - Layout panel
   */
  toolbarActionBar?: boolean;

  /**
   * M1c: Hello release: Flags/Snackbars/Modals
   * - Snackbars shown in Whiteboards location
   * - Save changes button on DB embed
   * - Flags/section messages shown in Whiteboards location
   */
  flagsSnackbarsModals?: boolean;

  /**
   * M1d: Hello release: Other
   * - Best effort initial and dynamic sizing
   * - E2E tests, performance tests, SLOs, integration tests
   * - Value & row entries overhead
   * - Create empty database from Whiteboards
   * - Experimentation analytics
   */
  helloReleaseOther?: boolean;

  /**
   * M1e: Customer release: Change-boarding
   * - 'New' indicator on databases element in whiteboards toolbar
   * - User awareness of new functionality
   */
  changeboarding?: boolean;
};
